import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { UseFormRegister, UseFormWatch } from "react-hook-form";
import { userFormType } from "../../../ModalRegister";
import "./InputEmail.scss";

interface IInputEmail {
  register: UseFormRegister<userFormType>;
  watch: UseFormWatch<userFormType>;
}

const InputEmail = ({ register, watch }: IInputEmail) => {
  const [inputValue, setInputValue] = useState("");
  const [inputFocus, setInputFocus] = useState(false);
  const [fieldError, setFieldError] = useState(false);
  const [shortError, setShortError] = useState(false);
  const [longError, setLongError] = useState(false);
  const name = watch("email");

  useEffect(() => {
    setInputValue(name);
    setFieldError(false);
    setShortError(false);
    setLongError(false);
  }, [name]);

  const handleOnFocus = () => {
    setInputFocus(true);
  };

  const handleOnBlur = () => {
    if (inputValue.length === 0) {
      setInputFocus(false);
      setFieldError(true);
    }
    if (inputValue.length < 2 && inputValue.length > 0) {
      setShortError(true);
    }
    if (inputValue.length > 20) {
      setLongError(true);
    }
  };
  return (
    <div className="entrance-f-item-bc">
      <div
        className={`form-control-bc default ${
          fieldError || shortError || longError ? "invalid" : ""
        } ${inputFocus ? "focused" : ""}`}
      >
        <label className="form-control-label-bc inputs">
          <input
            type="email"
            className="form-control-input-bc"
            {...register("email", {
              required: true,
              min: 2,
            })}
            onFocus={handleOnFocus}
            onBlur={handleOnBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">
            {t("admin.Email")}
          </span>
        </label>
        {fieldError || shortError || longError ? (
          <div className="form-control-message-holder-bc">
            <span className="form-control-message-bc">
              {fieldError ? t("admin.Thisfieldisrequired") : ""}
              {shortError ? t("admin.Tooshort") : ""}
              {longError ? t("admin.Toolong") : ""}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export { InputEmail };
